<div class="cms__content">
    <app-reports-header></app-reports-header>
  
    <div class="top__heading">
      <h3>Whitelisted SMS</h3>
      <a>
        <!-- <button class="default__button float-right">Back</button> -->
        <button style="margin-right: 10px" (click)="addSms()">Add SMS</button>
      </a>
    </div>
  
    <div class="row">
      <div class="filter__group col-12 col-md-6">
        <input type="date" class="custom__field" #dateInput [attr.max]="maxDate" (input)="dateChange($event)">
 
        <input
          #threadInput
          type="text"
          class="custom__field"
          placeholder="Search By Thread"
          (keydown.enter)="threadId($event)"
        />
        <input
          #commandInput
          type="text"
          class="custom__field"
          placeholder="Search By Command"
          (keydown.enter)="commandId($event)"
        />
  
        <select
          #statusSelect
          class="custom__field"
          (change)="selectStatus($event)"
        >
          <option selected hidden>Select Status</option>
          <option value="ALL">ALL</option>
          <option *ngFor="let data of statusList" [value]="data.value">
            {{ data.label }}
          </option>
        </select>
      </div>
  
      <div class="download__report col-md-6">
        <button
          [disabled]="whitelistedResponse.length <= 0"
          class="default__button"
          (click)="downloadTablePdf()"
          title="Download PDF"
        >
          PDF
          <img src="./assets/pdf.svg" alt="download" />
        </button>
        <button
          [disabled]="whitelistedResponse.length <= 0"
          class="default__button"
          (click)="downloadTableExcel()"
          title="Download Excel"
        >
          Excel
          <img src="./assets/excel.svg" alt="download" />
        </button>
        <button
          [disabled]="whitelistedResponse.length <= 0"
          class="default__button"
          (click)="downloadTableCSV()"
          title="Download CSV"
        >
          CSV
          <img src="./assets/csv.svg" alt="download" />
        </button>
      </div>
    </div>
  
    <div class="col-12 date__pagination">
      <div class="reload">
        <p>
          Report generated on : {{ currentDate | date : "dd-MM-yyyy HH:mm:ss" }}
        </p>
        <img src="../../../assets/refresh.png" alt="reload" (click)="refresh()" />
      </div>
      <p>
        Showing&nbsp;
        <select
          name=""
          id=""
          (change)="changePageSize($event)"
          [disabled]="whitelistedResponse.length <= 0"
        >
          <option *ngFor="let ele of pageSizeArray" [value]="ele">
            {{ ele }}
          </option></select
        >&nbsp;&nbsp;
        <span *ngIf="whitelistedResponse.length > 0 && totalElementCount > 0">
          out of {{ totalElementCount }}</span
        >
        Records
      </p>
    </div>
  
    <div class="col-12 list__table">
      <div class="row table__scroller">
        <table class="custom__iptv__table" #reportTable id="reportTable">
          <thead>
            <tr>
              <th>Sl No.</th>
              <th>Log Date</th>
              <th>Thread ID</th>
              <th>Command</th>
              <th>Status</th>
              <th>Request</th>
              <th>Response</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="loader; else showList">
              <td class="loader-cell">
                <div class="loader"></div>
              </td>
            </tr>
            <tr *ngIf="!loader && whitelistedResponse.length <= 0">
              <td class="loading" colspan="10">
                <span>{{ this.settingDisplayValue() }}</span>
              </td>
            </tr>
          
            <ng-template #showList>
              <tr *ngFor="let report of whitelistedResponse; index as i">
                <td>{{ i + 1 }}</td>
                <td class="ellipsis-cell">
                  {{ report.logDate }}
                </td>
                <td class="ellipsis-cell">{{ report.threadId }}</td>
                <td class="ellipsis-cell">{{ report.command }}</td>
                <td class="ellipsis-cell">{{ report.status }}</td>
                <td class="ellipsis-cell">{{ report.request }}</td>
                <td class="ellipsis-cell">{{ report.response }}</td>
              </tr>
            </ng-template>
          </tbody>
          
        </table>
      </div>
  
      <div *ngIf="whitelistedResponse" class="pagination__button__group">
        <button [disabled]="pageNumber === 1" (click)="changePageNumber('back')">
          &lt;
        </button>
        <span>Page {{ pageNumber }} of {{ totalPageCount }}</span>
        <button
          [disabled]="pageNumber === totalPageCount"
          (click)="changePageNumber('front')"
        >
          &gt;
        </button>
      </div>
    </div>
  </div>
  